import React from "react";
import { ArrayField, Datagrid, FunctionField, ReferenceField, TextField, useRecordContext } from "react-admin";
import { Grid, useMediaQuery } from "@mui/material";
import { settings } from "app";
import { administrationRequests } from "api/administrationApi";
import SecuredComponent from "server/security/SecuredComponent";
import permissions from "app/permissions";
import RemoveDialog from "./Dialogs/RemoveDialog";
import AddCourseDefinisionsDialog from "./Dialogs/AddCourseDefinisionsDialog";
import { SectionTitle } from "features/SectionTitle";

const CourseDefinitionsSection = () => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));
  const record = useRecordContext();

  if (!record?.courses?.length) return;

  return (
    <>
      <SectionTitle
        title="Курсове"
        textAlign="center"
        sx={{ marginTop: "2rem" }}
      />
      <Grid
        container
        spacing={2}
        sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
      >
        <Grid
          item
          xs={12}
        >
          <ArrayField
            source="courses"
            label=""
          >
            <Datagrid
              bulkActionButtons={false}
              rowClick={false}
              sx={settings.style.secondaryLeftAlignedDatagrid}
            >
              <TextField
                source="name"
                label="Наименование"
                sortable={false}
              />
              <ReferenceField
                source="departmentId"
                reference={administrationRequests.getDepartmentsSelect()}
                label="Катедра"
                sortable={false}
              >
                <TextField source="fullName" />
              </ReferenceField>
              <ReferenceField
                source="clinicId"
                reference={administrationRequests.getClinicsSelect()}
                label="Клиника"
                sortable={false}
              >
                <TextField source="nameBg" />
              </ReferenceField>
              <SecuredComponent permission={permissions.canManageSpecializationsCurricula}>
                <FunctionField
                  render={rec => (
                    <RemoveDialog
                      curriculumId={record?.id}
                      id={rec?.definitionId}
                      type="courses"
                      label="курс"
                    />
                  )}
                />
              </SecuredComponent>
            </Datagrid>
          </ArrayField>
          <SecuredComponent permission={permissions.canManageSpecializationsCurricula}>
            <AddCourseDefinisionsDialog curriculumId={record?.id} />
          </SecuredComponent>
        </Grid>
      </Grid>
    </>
  );
};

export default CourseDefinitionsSection;
